import React, {ReactElement, useCallback, useEffect} from "react";
import {connectInfiniteHits, connectStats} from "react-instantsearch-dom";
import {InfiniteHitsProvided, StatsProvided} from "react-instantsearch-core";
import {AlgoliaWine} from "./winePickerModel";
import {WinePickerResultWine} from "./WinePickerResultWine";
import {FormattedMessage} from "react-intl";
import {useInView} from "react-intersection-observer";
import {useAppDispatch} from "../../lib/redux/hooks";
import {useIsWinePicked, winePickerActions} from "./winePickerSlice";
import {Language} from "../i18n/translations";

export interface WinePickerResultsProps {
    language: Language
}

export function WinePickerResults(props: WinePickerResultsProps): ReactElement {
    return <div className="w-full">
        <Stats/>
        <InfiniteHits language={props.language} />
    </div>
}

interface StatsProps {

}

function StatsComponent(props: StatsProps & StatsProvided): ReactElement {
    return <div className="font-barlow font-semibold py-4 leading-snug flex items-center gap-4">
        <span className="flex-auto"><FormattedMessage id="winepicker.results.noResults" values={{hits: props.nbHits}}/></span>
    </div>
}

const Stats = connectStats(StatsComponent);

interface InfiniteHitsProps {
    language: Language
}

function InfiniteHitsComponent(props: InfiniteHitsProps & InfiniteHitsProvided<AlgoliaWine>): ReactElement {
    const refineNext = props.refineNext;
    const hasMore = props.hasMore;
    const {ref, inView} = useInView();
    const dispatch = useAppDispatch();
    const isWinePicked = useIsWinePicked();

    useEffect(() => {
        if (inView && hasMore) {
            refineNext();
        }
    }, [inView, hasMore]); // eslint-disable-line

    const setSelected = useCallback(
        (wine: AlgoliaWine, selected: boolean) =>
            dispatch(winePickerActions.setWinePicked({wine, selected})),
        [dispatch]
    );

    return (
        <>
            <ul className="flex flex-col gap-1">
                {props.hits.map(hit => {
                    return <li key={hit.objectID}>
                        <WinePickerResultWine
                            key={hit.objectID}
                            wine={hit}
                            selected={isWinePicked(hit)}
                            onSetSelected={setSelected}
                            language={props.language}
                        />
                    </li>})
                }
            </ul>
            <div ref={ref} />
        </>
    );
}

const InfiniteHits = connectInfiniteHits(InfiniteHitsComponent);
